var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',{staticClass:"content-area",attrs:{"id":"main-content"}},[_c('v-container',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(Component,{tag:"component"})],1)]}}])})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }